import { Navigate, Outlet } from "react-router-dom"
import AuthService from "../services/auth.service"
export default function ProtectedRoute(props){  
    if(!AuthService.isLoggedIn()){
        return <Navigate to="/login" />
    }  
    return <Outlet />
}